import { useState } from 'react';
import PalletItem from './PalletItem';
import ColumModal from '../../../../../generic/Layouts/ColumModal';
import { AppModal } from '../../../../../generic/ui/Modal';
import SelectDriver from '../../trucks/SelectDriver';
import AddProductModal from '../../market/Collect/Components/AddProductModal';
import { IPalletEdited } from '../types/palletItem';
import SettingsModsl from '../Components/SettingsModsl';
import PalletsToChange from '../../../../../generic/modals/PalletsToChange';
import ProductModal from '../../market/Collect/Components/ProductModal';
import TransferTeudaModal from '../../../../../generic/modals/TransferTeudaModal/TransferTeudaModal';
import TitlesList from '../../../../../generic/titlesRowItem/TitlesList';
import TeudaCreatePageLayout from '../Components/TeudaCreatePageLayout';
import TeudaCreateScrollArea from '../Components/TeudaCreateScrollArea';
import TeudaTitleCard from '../Components/TeudaTitleCard';
import PreTeudaSelector from '../Components/PreTeudaSelector';
import TeudaScanBar from '../Components/TeudaScanBar';
import TeudaTabs from '../Components/TeudaTabs';
import PalletRow from '../Components/PalletRow';
import { VirtualList } from '../../../../../generic/ui/VirtualList';
import TeudaActionDock from '../Components/TeudaActionDock';
import TeudaImagesPanel from '../Components/TeudaImagesPanel';
import KbdChipButton from '../../../../../generic/ui/KbdChipButton/KbdChipButton';
import PaperclipIcon from '../../../../../generic/icons/IconLib/PaperclipIcon';
import useCreateTeuda from '../services/hooks/useCreateTeuda';

// Module-level: VirtualList keys its measurement cache on this function's identity.
const getPalletKey = (pallet: IPalletEdited): number => pallet.Pallet_Num;

function CreateTeuda() {
    const {
        t,
        id,
        subID,
        isEditMode,
        titleTeuda,
        clientName,
        navigateBack,
        isAllowToEdit,
        isSaveAllow,
        selectedClient,
        activeTab,
        handleTabClick,
        expandedPallets,
        toggleExpanded,
        setDate,
        palletInput,
        setPalletInput,
        renderPalletList,
        searchEnterPallet,
        handleNewPallet,
        handleControlSettings,
        handleCloseSettings,
        handleControlPalletToChangeModal,
        createTeuda,
        isOpenSelectDriver,
        setIsOpenSelectDriver,
        isOpenPalletObject,
        setIsOpenPalletObject,
        isOpenPalletToChangeModal,
        isOpenSettings,
        isOpenTransferTeudaModal,
        setIsOpenTransferTeudaModal,
        isOpenAddModal,
        handleOpenAddModal,
        isOpenProductModal,
        handleControlProductModal,
        tempPalletObject,
        savePalletinTheList,
        selectedProduct,
        selectedPallet,
        PropsForPalletItem,
        settingsModalProps,
        addProductModalProps,
        selectedProductModalProps,
        selectDriverP,
        palletToChangeProps,
        teudaImages,
        showImagesToggle,
        isImagesOpen,
        toggleImages,
    } = useCreateTeuda();
    // State, not a ref: the list's layout effects run before this ancestor's ref attaches.
    const [scrollEl, setScrollEl] = useState<HTMLDivElement | null>(null);

    const title = isEditMode
        ? t('teudot_create_page_title_ids', { id })
        : t('teudot_create_page_title');
    const showList = Boolean(selectedClient || isEditMode);

    return (
        <TeudaCreatePageLayout title={title}>
            {isOpenTransferTeudaModal && isEditMode && (
                <ColumModal
                    title={`העברת תעודה`}
                    Children={TransferTeudaModal}
                    controlFunc={() => setIsOpenTransferTeudaModal(false)}
                    childrenProps={{ teudaID: id, subID: subID }}
                    size='md'
                />
            )}
            {isOpenProductModal && (
                <AppModal
                    title={`${selectedProduct?.ProductDesc.trim()} ${selectedProduct?.VarietyDesc.trim()} ${selectedProduct?.SizeID.trim()}`}
                    Children={ProductModal}
                    controlFunc={handleControlProductModal}
                    childrenProps={selectedProductModalProps}
                    size='sm'
                />
            )}
            {isOpenPalletToChangeModal && isEditMode && (
                <AppModal
                    title={`תעודה ${id} - ${subID}`}
                    Children={PalletsToChange}
                    controlFunc={handleControlPalletToChangeModal}
                    childrenProps={palletToChangeProps}
                    
                />
            )}
            {isOpenSettings && (
                <AppModal
                    title={t('teudot_create_modal_title_title')}
                    controlFunc={handleCloseSettings}
                    Children={SettingsModsl}
                    childrenProps={settingsModalProps}
                    
                />
            )}
            {isOpenAddModal && (
                <AppModal
                    title={
                        selectedPallet?.pallet
                            ? t('create_product_modal_title_created', {
                                  id: selectedPallet.pallet,
                              })
                            : t('create_product_modal_title_new')
                    }
                    Children={AddProductModal}
                    controlFunc={handleOpenAddModal}
                    childrenProps={addProductModalProps}
                    // size='lg'
                />
            )}
            {isOpenSelectDriver && (
                <ColumModal
                    title='בחר נהג'
                    controlFunc={() => setIsOpenSelectDriver(false)}
                    Children={SelectDriver}
                    childrenProps={selectDriverP}
                />
            )}
            {isOpenPalletObject && (
                <ColumModal
                    title={'אישור שליפת משטח'}
                    controlFunc={() => setIsOpenPalletObject(false)}
                    Children={() => (
                        <TitlesList<IPalletEdited>
                            list={tempPalletObject ? [tempPalletObject] : []}
                            uniqueKey={'Pallet_Num'}
                            Element={PalletItem}
                            noPadding={false}
                            additionalData={{ isDisabled: true }}
                        />
                    )}
                    childrenProps={{}}
                    acceptFunction={savePalletinTheList}
                />
            )}

            <TeudaCreateScrollArea
                ref={setScrollEl}
                scrollHeader={
                    isEditMode && titleTeuda ? (
                        <TeudaTitleCard
                            data={titleTeuda}
                            onEdit={handleControlPalletToChangeModal}
                        />
                    ) : (
                        <PreTeudaSelector
                            clientName={clientName}
                            setDate={setDate}
                            onSettings={handleControlSettings}
                            showSettings={!!isAllowToEdit}
                        />
                    )
                }
                stickyHeader={
                    showList ? (
                        <TeudaScanBar
                            input={palletInput}
                            setInput={setPalletInput}
                            onEnter={searchEnterPallet}
                            onAddPallet={isAllowToEdit ? handleNewPallet : undefined}
                        />
                    ) : null
                }
            >
                {showList && (
                    <TeudaTabs
                        activeTab={activeTab}
                        onChange={handleTabClick}
                        isAllowToEdit={!!isAllowToEdit}
                        tabsAside={
                            showImagesToggle ? (
                                <KbdChipButton
                                    variant='accent'
                                    aria-expanded={isImagesOpen}
                                    aria-label={t('teudot_create_images_toggle')}
                                    title={t('teudot_create_images_toggle')}
                                    onClick={toggleImages}
                                >
                                    <PaperclipIcon size={18} />
                                </KbdChipButton>
                            ) : null
                        }
                        beforeList={
                            showImagesToggle ? (
                                <TeudaImagesPanel
                                    open={isImagesOpen}
                                    images={teudaImages.images}
                                    comment={teudaImages.comment}
                                    isLoading={teudaImages.isLoading}
                                />
                            ) : null
                        }
                    >
                        <VirtualList
                            items={renderPalletList}
                            getItemKey={getPalletKey}
                            scrollElement={scrollEl}
                            scrollResetKey={activeTab}
                            renderItem={(pallet) => (
                                <PalletRow
                                    {...pallet}
                                    activeTab={activeTab}
                                    expanded={expandedPallets.has(pallet.Pallet_Num)}
                                    onToggleExpanded={toggleExpanded}
                                    {...PropsForPalletItem}
                                />
                            )}
                        />
                    </TeudaTabs>
                )}
            </TeudaCreateScrollArea>

            <TeudaActionDock
                onBack={navigateBack}
                onSave={createTeuda}
                canSave={!!isSaveAllow}
                backAriaLabel={t('buttons:back')}
                saveLabel={t('buttons:save')}
            />
        </TeudaCreatePageLayout>
    );
}

export default CreateTeuda;
